export default "__VITE_ASSET__gjXr8lyG__"